import React, { FC, ReactElement } from 'react';
import { MainZoneDataProps } from '../DemoZoneMain';
import DemoZoneListItem from './DemoZoneListItem';
import { useSelector } from 'react-redux';
import { getDemozoneThemeList } from '../../../../stores/reducers/userData';
import './demozone-list.sass';
import { ZoneDataProps } from '../DemoZone';
import localeFieldResolver from '../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../stores/reducers/sections';

interface Props {
  zoneCode: string;
  zoneData: ZoneDataProps;
}

const DemoZoneList: FC<Props> = ({ zoneCode, zoneData }): ReactElement => {
  const zones = useSelector(getDemozoneThemeList);
  const { activeLangState } = useSelector(internalizationState);

  return (
    zones && zones.blocks.length ?
      <section className="inner-section bg-footer">
        <div className="container">
          <div className="inner-section__head">
            <div className="section-title zonedata-items__title">{ localeFieldResolver(zoneData, 'title', activeLangState) }</div>
          </div>
          <div className="zonedata-items">
            {
              zones && zones.blocks.map((zone: MainZoneDataProps): ReactElement => {
                if (zone.relatedPage !== zoneCode) {
                  return <DemoZoneListItem zoneItem={zone} key={zone.id} />
                }
                return <></>
              })
            }
          </div>
        </div>
      </section>
    :
      <></>
  )
}

export default DemoZoneList
